// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__qaY_4","list":"PatternAutocomplete_list__166sU"};